<div *ngIf="checkViewMode('edit') && attribute.key != 'Duração do projeto'" [class]="'form-group txt_'+getOptionByKey(attribute,'identifier')">
  <label for="">
    {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : attribute.key}}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <input class="form-control m-input"
         type="text"
         [tabindex]="getOptionByKey(attribute,'tabIndex')"
         [disabled]="getOptionByKey(attribute,'disabled')"
         [required]="getOptionByKey(attribute,'required')"
         [id]="'txt_'+getOptionByKey(attribute,'identifier')"
         [(ngModel)]="attribute.value"
         currencyMask
         (ngModelChange)="onChange()"
         />
</div>

<div *ngIf="checkViewMode('view')">
  <p><span>{{ attribute.key }}: </span> {{ attribute.value | currency:'BRL' }}</p>
</div>
